export const API_BASE_URL: string = 'https://thexdev.herokuapp.com/api';
export const API_VERSION: string = 'v1';

const API = {
  enter: `${API_BASE_URL}/${API_VERSION}/enter`,
  post: `${API_BASE_URL}/${API_VERSION}/posts`,
  message: `${API_BASE_URL}/${API_VERSION}/messages`,
  pre_enter: `${API_BASE_URL}/${API_VERSION}/pre-enter`,
  inbox: {
    latest: `${API_BASE_URL}/${API_VERSION}/messages`,
  },
};

export default API;
